import { render, staticRenderFns } from "./WorkUnitPrependHeader.vue?vue&type=template&id=2ab0bd21"
import script from "./WorkUnitPrependHeader.vue?vue&type=script&lang=js"
export * from "./WorkUnitPrependHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports